import { Box } from '@mui/material';

export default function TemplateColumnHeader({ children }) {
  return (
    <Box
      component="span"
      sx={{
        color: '#334155',
        fontSize: '0.6875rem',
        fontWeight: 700,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
      }}
    >
      {children}
    </Box>
  );
}
